import React, { useState } from "react";
import Searchbar from "./Searchbar";
import SearchResults from "./SearchResults";

const ParentComponent = () => {
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearch = (query) => {
    setSearchQuery(query);
  };

  const handleProductClick = (productId, category) => {
    console.log("Product clicked:", productId, category);
    // Navigate to product details or perform other actions
  };

  return (
    <div>
      <Searchbar onSearch={handleSearch} />
      <SearchResults
        searchQuery={searchQuery}
        onProductClick={handleProductClick}
      />
    </div>
  );
};

export default ParentComponent;